import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import i18n from '@/common/i18n/i18n'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: {
      path: '/eventDetail'
    }
  },
  {
    path: '/eventDetail',
    name: 'EventDetail',
    component: () => import('@/views/EventDetail/index.vue')
  },
  {
    path: '/performance',
    name: 'Performance',
    component: () => import('@/views/Performance/index.vue')
  },
  {
    path: '/shoppingBasket',
    name: 'ShoppingBasket',
    component: () => import('@/views/ShoppingBasket/index.vue')
  },
  {
    path: '/tnc',
    name: 'Tnc',
    component: () => import('@/views/Tnc/index.vue')
  },
  {
    path: '/recon/receipt',
    name: 'Receipt',
    component: () => import('@/views/Receipt/index.vue')
    // component: () => import('@/views/testReceipt.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  // mode: 'hash',
  routes
})

router.beforeEach((to, from, next) => {
  if (store.state?.eventInfo?.name) {
    document.title = store.state.eventInfo.name
  }
  // 需要 reserve 数据的page
  const names = ['ShoppingBasket', 'Tnc', 'Receipt']
  if (names.includes(to.name)) {
    if (store.state.reserveInfo) {
      next()
    } else {
      /* if (store.state.eventInfo && store.state.eventInfo.eventId) {
        next({ path: '/', query: { eventId: store.state.eventInfo.eventId } })
      } else { */
      window.location.href = Vue.prototype.$cwLink + '?lang=' + i18n.locale
      // }
    }
  } else {
    next()
  }
})

export default router
